import HTTP from "../../utils/Http";
import Cookies from "js-cookie";
import * as actions from "./types";

const initialState = {
  permissions: [],
  isAuthenticated: false,
  isLoading: false,
  error: null
};

export default function(state = initialState, { type, payload = null }) {
  switch (type) {
    case actions.AUTH_CHECK:
      return authCheck(state);
    case actions.AUTH_LOADING:
      return startLoading(state);
    case actions.AUTH_LOGIN_START:
      return startLoading(state);
    case actions.AUTH_LOGIN_SUCCESS:
      return authLoginSuccess(state, payload);
    case actions.AUTH_LOGIN_FAIL:
      return authLoginFail(state, payload);
    case actions.AUTH_GET_USER_START:
      return startLoading(state);
    case actions.AUTH_GET_USER_SUCCESS:
      return authGetUserSuccess(state, payload);
    case actions.AUTH_GET_USER_FAIL:
      return authGetUserFail(state, payload);
    case actions.AUTH_LOGOUT:
      return authLogout(state);
    default:
      return state;
  }
}

function startLoading(state) {
  state = Object.assign({}, state, { isLoading: true });
  return state;
}

function authLoginSuccess(state, payload) {
  Cookies.set("id", payload, { expires: 7 });
  localStorage.setItem("token", payload);
  HTTP.defaults.headers.common["Authorization"] = `Bearer ${payload}`;
  state = Object.assign({}, state, {
    isAuthenticated: true,
    isLoading: false,
    error: null
  });
  return state;
}

function authLoginFail(state, payload) {
  state = Object.assign({}, state, {
    isAuthenticated: false,
    isLoading: false,
    error: payload
  });
  return state;
}

function authCheck(state) {
  state = Object.assign({}, state, {
    //isAuthenticated: !!Cookies.get("id")
    isAuthenticated: !!localStorage.getItem("token")
  });
  
  if (state.isAuthenticated) {
    HTTP.defaults.headers.common[
      "Authorization"
      ] = `Bearer ${localStorage.getItem("token")}`;
  }
  
  return state;
}

function authGetUserSuccess(state, payload) {
  state = Object.assign({}, state, {
    currentUser: payload,
    isLoading: false,
    permissions: payload.permissions
  });
  return state;
}

function authGetUserFail(state, payload) {
  state = Object.assign({}, state, {
    currentUser: null,
    isLoading: false,
    error: payload
  });
  return state;
}

function authLogout(state) {
  Cookies.remove("id");
  localStorage.removeItem('token');
  
  state = Object.assign({}, state, {
    isAuthenticated: false,
    currentUser: null,
    error: null,
    isLoading: false
  });
  
  return state;
}



// WEBPACK FOOTER //
// ./src/system/store/auth/reducers.js